window.PluginsHandler = class {

	static async load(base) {
		await Promise.all([
			this.horizontalScroll(base),
			this.loadSelect2(base),
			this.loadSelectPicker(base),
			this.loadSelectRadio(base),
			this.loadSelectCheckbox(base),
			this.loadSwitchery(base),
			this.loadintlTelInput(base),
			this.loadSegment(base),
			this.loadClipboard(base),
			this.loadMoment(base),
		]);
		
	}

	// TODO : se podria mejorar buscando una sola vez por los elementos [data-plugin] y luego filtrar por cada plugin

	static async horizontalScroll(base) {
		let elements = base.find('.horizontal-scroll');
		if( elements.length ) {
			if(!UtilityHelper.isMobile()){             
				await Library.load(['scrollbooster']);
				for( let el of elements) {
					let viewport = $(el).parent();
					viewport.css('overflow', 'hidden');

					let sb = new ScrollBooster({
						viewport: viewport[0],
						content: el,
						direction: "horizontal",
						emulateScroll: false,
						scrollMode: "native",
						onClick: (state, event) => {
							if(state.isMoving == true){
								event.preventDefault();
								event.stopPropagation();
								return;
							}
						},
					});
					
					// Ver si esta en una tab
					let tab = $(el).closest('.tab-pane');
					if( tab.length ) {
						// obtener id de columna
						let col = tab.attr('data-col');
						// hacer bind on solapa
						tab.closest('.nav-tabs').find(`.nav-link[data-col="${col}"]`).on('click', async function() {
							// actualizar scrollbooster
							await new Promise(r => setTimeout(r, 50));
							sb.updateMetrics();
						});
					}
					$(el).parent().on('scroll', UtilityHelper.throttle( 250, function(){
						if($(this).scrollLeft() > 25) {
							$(this).closest('.relative').children('.horizontal-scroll-more').addClass('opacity-hide');
						} else {
							$(this).closest('.relative').children('.horizontal-scroll-more').removeClass('opacity-hide');
						}
					}));
				}
			}
			else {
				for( let el of elements) {
					var $el = $(el);
					// Fix Mobile Chrome Issue - Esta contabilizando los slots vacios del grid template armando un scroll quasi infinito
					$el.css('--elements-count', $el.children().length || 0);
					$el.on('scroll', UtilityHelper.throttle( 250, function(){
						if($(this).scrollLeft() > 25) {
							$(this).closest('.relative').children('.horizontal-scroll-more').addClass('opacity-hide');
						} else {
							$(this).closest('.relative').children('.horizontal-scroll-more').removeClass('opacity-hide');
						}
					}));
				}
	
			}
		} 
	}

	static async loadintlTelInput(base) {
		let elements = base.find('input[data-plugin="intlTelInput"]');
		if( elements.length ) {
			await Library.load(['intlTelInput']);
			for( let elem of elements) {
				// https://github.com/jackocnr/intl-tel-input?tab=readme-ov-file#features
				intlTelInput(elem, {
					// countryOrder: ['ar', 'br', 'cl', 'co', 'ec', 'es', 'mx', 'pe', 'py', 'uy', 'vz'], // Dado que ahora hay buscador, no hace falta priorizarlos
					nationalMode: false,
					autoPlaceholder: "aggressive",
					initialCountry: NOW.vars.user_country,
					separateDialCode: true,	// mostrar codigo pais por separado y no editable
					strictMode: true, // no permitir valores invalidos
				});
			}
		}
	}

	static async loadSwitchery(base) {

		let elements = base.find('input[data-plugin="switchery"]');
		if( elements.length ) {
			await Library.load(['switchery']);
			for( let elem of elements) {
				var size = $(elem).data('size');
				var init = new Switchery(elem, {
					size: size? size : 'default',
				});
			}
		}

	}

	static async loadSelectCheckbox(base) {

		let elements = base.find('select[data-plugin="select-checkbox"]');
		if( elements.length ) {
			for( let elem of elements) {
				new SelectCheckboxUi(elem);
			}
		}

	}

	static async loadSelectRadio(base) {

		let elements = base.find('select[data-plugin="select-radio"]');
		if( elements.length ) {
			for( let elem of elements) {
				new SelectRadioUi(elem);
			}
		}

	}

	static async loadSegment(base) {
		let elements = base.find('select[data-plugin="segment"]');
		if( elements.length ) {
			await Library.load(['segment']);
			for(let select of elements) {
				var $select = $(select);
				$select.Segment({
					tpl: base,
				});
			}
		}
	}

	static async loadClipboard(base) {
		let elements = base.find('button[data-plugin="clipboard"]');
		if( elements.length ) {
			for( let link of elements) {
				link.addEventListener('click', function(e) {
					e.preventDefault();
					const el = document.createElement('textarea');
					el.value = link.dataset['clipboardtext'];
					el.setAttribute('readonly', '');
					el.style.position = 'absolute';
					el.style.left = '-9999px';
					document.body.appendChild(el);
					el.select();
					document.execCommand('copy');
					document.body.removeChild(el);
				});
			}
		}
	}

	static async loadSelect2(base) {
		// Process Plugins
		// Select2
		let elements = base.find('select[data-plugin="select2"],button[data-plugin="select2"]');
		if( elements.length ) {
			await Library.load(['select2']);
			for( let select of elements) {
				let $select = $(select);

				var s2instance = $select.select2({
					placeholder: $select.attr('placeholder') || $select.attr('data-none-selected-text') || "Seleccionar",
					escapeMarkup: function (text) { return text; },
					allowClear: true,
					closeOnSelect: !$select.attr('multiple'),
					sorter: function(data) {
						return data.sort(function(a, b) {
							return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
						});
					}
				});
				let value = $select.attr('value');
				if(value) {
					if($select.attr('multiple')) {
						s2instance.val(UtilityHelper.split(value) )
					}
					else {
						s2instance.val(value);
					}
					s2instance.trigger('change.select2');
				}
			}
		}

		
	}

	static async loadSelectPicker(base){
		var elements = base.find('select[data-plugin="selectpicker"]');
		if( elements.length ) {
			await Library.load(['selectpicker']);
			for(let select of elements) {
				let $select = $(select);

				$select.selectpicker({
					style: $select.attr('data-style') || '',
				});

				$select.parent().addClass($select.attr('data-container-style') || '');

				let value = $select.attr('value');
				if(value) {
					if($select.attr('multiple')) {
						$select.selectpicker('val', UtilityHelper.split(value) );
					}
					else {
						$select.selectpicker('val', value );
					}
					$select.selectpicker('refresh');
				}

				//$select.selectpickerStyler();
			}
		}
	}

	static async loadMoment(base) {
		const elements = base.find('[data-plugin="moment"]');
		if( elements.length ) {
			// await Library.load(['moment']);
			for (const element of elements) {
				const $element = $(element);
				const date = $element.html();
				const format = $element.attr("data-format");
				if (format == "fromNow")
					$element.html(
						moment(date + "Z")
							.local()
							.fromNow()
					);
				else {
					$element.html(
						moment(date + "Z")
							.local()
							.format(format)
					);
				}
			}
		}
	}
}